// extracted by mini-css-extract-plugin
export default {"pageLayout":"AllJobProspects-module__pageLayout___bV5Xx"};